import {
  FilterStructure,
  FilterType,
  ShapeStructure,
  ShapeType,
} from '../../reportsTypes';

export function extractNamesFromShape(
  shapeStructure: ShapeStructure,
  shapeType: ShapeType | null,
): string[] {
  if (shapeType === 'shape' && shapeStructure.shape) {
    return shapeStructure.shape.map((item) => item.name);
  } else if (shapeType === 'multiShape' && shapeStructure.multiShape) {
    return shapeStructure.multiShape.map((item) => item.name);
  } else if (shapeType === 'worldShape' && shapeStructure.worldShape) {
    return shapeStructure.worldShape.map((item) => item.name);
  } else if (shapeType === 'ports' && shapeStructure.ports) {
    return shapeStructure.ports.map((item) => item.name);
  } else {
    return [];
  }
}

export function extractNamesFromFilter(
  filterStructure: FilterStructure,
  _filterType: FilterType,
): string[] {
  if (filterStructure.normal) {
    return filterStructure.normal.map((item) => item.name);
  } else if (filterStructure.ship) {
    return filterStructure.ship.map((item) => item.name);
  } else if (filterStructure.shiplist) {
    return filterStructure.shiplist.map((item) => item.name);
  } else {
    return [];
  }
}
